<mat-toolbar class="header-container {{customClass}} flex flex-col! justify-center items-center lg:flex-row! lg:justify-between gap-3">
  <div class="flex flex-row gap-2 lg:gap-4 xl:gap-5 items-center justify-center gray-color">
    <pin-logo [type]="logoType"></pin-logo>
    @if (displaySessionDetails) {
      <pin-bank-logo [bankName]="bankName" [bankCustomizationData]="bankCustomizationData"></pin-bank-logo>
    }
  </div>


  @if (displaySessionDetails) {
    <nav class="flex flex-row main-navigation" role="navigation" aria-label="user account buttons">
    <button matButton class="actions-menu" id="actions-button" [matMenuTriggerFor]="actionsMenu">
      <mat-icon aria-hidden="true" class="md-20">menu</mat-icon>
      <span class="body-md-regular color-content-subtle text-nowrap-ellipsis no-print">ACTIONS</span>
    </button>

    <button matButton #profileMenuTrigger="matMenuTrigger" id="profile-button" [matMenuTriggerFor]="profileMenu">
      <mat-icon aria-hidden="true" class="md-20">person</mat-icon>
      <span id="header-customer-name" class="body-md-regular color-content-subtle text-nowrap-ellipsis">{{ displayName }}</span>
      <mat-icon aria-hidden="true" class="md-20">{{profileMenuTrigger.menuOpen ? 'expand_less' : 'expand_more'}}</mat-icon>
    </button>

    <mat-menu #actionsMenu="matMenu">
      <button mat-menu-item data-testid="where-can-my-funds-be-placed-menu-item" [routerLink]="['/where-can-my-funds-be-placed']">WHERE CAN MY FUNDS BE PLACED?</button>
      @if (hasCustomerLevelAccess && !ssoUser) {
        <button mat-menu-item data-testid="manage-account-access-menu-item" [routerLink]="['/manage-access']">MANAGE ACCOUNT ACCESS</button>
      }
    </mat-menu>

    <mat-menu #profileMenu="matMenu">
      @if (!ssoUser) {
        <button mat-menu-item data-testid="my-profile-settings-menu-item" [routerLink]="[internalRoutes.MY_PROFILE]">MY PROFILE SETTINGS</button>
      }
      <button mat-menu-item id="logout-button" data-testid="logout-button" class="btn-logout" i18n="@@header.logout" [routerLink]="['/logout']" fragment="ssoLogout">
        <mat-icon aria-hidden="true" class="md-20">logout</mat-icon>
        LOG OUT
      </button>
    </mat-menu>
  </nav>
  }
</mat-toolbar>
